module.exports = __webpack_public_path__ + "static/img/113.afbe87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/113.png
// module id = YMCS
// module chunks = 0